import { render, staticRenderFns } from "./CheckRealNameAndRisk.vue?vue&type=template&id=db115dd8&scoped=true&"
import script from "./CheckRealNameAndRisk.vue?vue&type=script&lang=js&"
export * from "./CheckRealNameAndRisk.vue?vue&type=script&lang=js&"
import style0 from "./CheckRealNameAndRisk.vue?vue&type=style&index=0&id=db115dd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db115dd8",
  null
  
)

export default component.exports